import { gql } from '@apollo/client'

export const EDIT_TEST_SESSION = gql`
  mutation EditTestSession($inputData: TestSessionDetailsInput!) {
    editTestSession(inputData: $inputData) {
      id
    }
  }
`
